export const BRAND_NAME = "Femei de succes";
export const BRAND_SUBTITLE = "din Republica Moldova";
export const BRAND_FULL_NAME = `${BRAND_NAME} ${BRAND_SUBTITLE}`;
